import React from 'react';
import { SimpleBarContext } from 'routes/surface/components/simplebar';
import useEventListener from 'hooks/use-event-listener';
import { notEqual } from 'utils/js';

export default function useControlPositionStyles() {
  const simpleBarContext = React.useContext(SimpleBarContext);
  const [style, setStyle] = React.useState({});

  useEventListener('resize', updateStyles);

  React.useEffect(() => updateStyles(), [simpleBarContext]);

  function updateStyles() {
    const rect = simpleBarContext
      .getSimpleBar()
      ?.contentWrapperEl?.getBoundingClientRect();

    const newStyles = rect && rectToStyles(rect);

    if (newStyles && notEqual(newStyles, style)) {
      setStyle(newStyles);
    }
  }

  return style;
}

function rectToStyles({
  top,
  left,
  width,
  height,
}: DOMRect): React.CSSProperties {
  return { top, left, width, height };
}
